import { render, staticRenderFns } from "./subordinationsList.vue?vue&type=template&id=68c97591&scoped=true"
import script from "./subordinationsList.vue?vue&type=script&lang=js"
export * from "./subordinationsList.vue?vue&type=script&lang=js"
import style0 from "./subordinationsList.vue?vue&type=style&index=0&id=68c97591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c97591",
  null
  
)

export default component.exports